import axios from 'axios';
let apiUrl = process.env.REACT_APP_API_URL;
let CancelToken = axios.CancelToken;
let cancel: any;

const getTransactions = async (tray: any, filters: any) => {
  try { 
    if (cancel !== undefined) cancel();
    const response = await axios.get(apiUrl + '/negotiations/trays/' + tray, {
      params: filters,
      cancelToken: new CancelToken(c => (cancel = c))
    });
    return response.data;
  } catch (error) {
    return [];
  }
};

const saveTransaction = (data: any) =>
  new Promise((resolve, reject) => {
    axios
      .post(apiUrl + '/negotiations/', data)
      .then(response => {
        if (response.data) {
          resolve(response.data);
        } else {
          reject(response.data.error);
        }
      })
      .catch(error => {
        reject(error);
      });
  });

const reject = (ids: any, type: any) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/negotiations/reject`, { ids: ids, type: type })
      .then(response => {
        if (response.data) {
          resolve(response.data);
        } else {
          reject(response.data.error);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
};

const getTotalTransactions = async (headerTray: any) => {
  try {
    const response = await axios.get(apiUrl + '/negotiations/total/' + headerTray);
    return response.data;
  } catch (error) {
    return {};
  }
};

const transactionService = { getTransactions, saveTransaction, getTotalTransactions, reject };

export default transactionService;
